package org.example.project.service

import kotlinx.browser.window
import kotlinx.coroutines.await
import kotlinx.serialization.builtins.ListSerializer
import kotlinx.serialization.encodeToString
import kotlinx.serialization.json.Json
import org.example.project.manager.LumaticaApiManager
import org.example.project.manager.LumaticaApiSettings
import org.example.project.utils.All
import org.w3c.fetch.RequestInit

object SystemBuildApi {
    private val json = Json { ignoreUnknownKeys = true; encodeDefaults = false }
    private fun url(action: String) = "${LumaticaApiSettings.getBaseUrl()}/api/systembuild/$action"

    suspend fun load(): List<All> {
        val response = window.fetch("${url("status")}?_=${js("Date.now()")}", RequestInit(headers = LumaticaApiManager.auditHeaders())).await()
        if (!response.ok) return emptyList()
        return runCatching {
            json.decodeFromString(ListSerializer(All.AllNames.serializer()), response.text().await())
        }.getOrDefault(emptyList())
    }

    suspend fun liveNodes(): List<All> {
        val response = window.fetch(url("live-nodes"), RequestInit(headers = LumaticaApiManager.auditHeaders())).await()
        if (!response.ok) return emptyList()
        return runCatching {
            json.decodeFromString(ListSerializer(All.AllNames.serializer()), response.text().await())
        }.getOrDefault(emptyList())
    }

    suspend fun execute(action: String, data: All): Boolean {
        val response = window.fetch(
            url(action),
            RequestInit(
                method = "POST",
                headers = LumaticaApiManager.auditHeaders("application/json"),
                body = json.encodeToString(ListSerializer(All.AllNames.serializer()), listOf(data))
            )
        ).await()
        return response.ok
    }

    suspend fun details(version: String): List<All> {
        val response = window.fetch(
            url("details"),
            RequestInit(
                method = "POST",
                headers = LumaticaApiManager.auditHeaders("application/json"),
                body = json.encodeToString(ListSerializer(All.AllNames.serializer()), listOf(All(buildVersion = version.removePrefix("build_"))))
            )
        ).await()
        if (!response.ok) return emptyList()
        return json.decodeFromString(ListSerializer(All.AllNames.serializer()), response.text().await())
    }

    suspend fun saveComment(version: String, comment: String): Boolean = execute(
        "save-comment",
        All(buildVersion = version.removePrefix("build_"), buildKommentar = comment)
    )

    suspend fun deleteComment(version: String, noteId: String) {
        val response = window.fetch(
            url("delete-comment"),
            RequestInit(
                method = "POST",
                headers = LumaticaApiManager.auditHeaders("application/json"),
                body = json.encodeToString(
                    ListSerializer(All.AllNames.serializer()),
                    listOf(All(buildVersion = version.removePrefix("build_"), id = noteId))
                )
            )
        ).await()
        if (!response.ok) error("Versionshinweis löschen: HTTP ${response.status}: ${response.text().await()}")
    }
}
